import './Navigationbar.css';
import { NavText } from '../Data/Data';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setStep } from '../../redux/reducer';
import { useEffect } from 'react';



const Navigationbar = () => {
   
    const step = useSelector((state) => state.step);
    const {name,email,phone} = useSelector((state) => state.PersonalInfo || {})
    const Dispatch = useDispatch();

    useEffect(()=>{
        if(!name.trim() || !email.trim() || !phone.trim()){
            if(step>1){
                Dispatch(setStep(1))
            }

        }
    },[name,email,phone,step,Dispatch])

    return (
        <div className='NavigationBar'>
            <div className='listContainer'>
                {NavText.map((item) => (
                    <div className='renderList' key={item.id}>
                        <button className='button' onClick={() => Dispatch(setStep(item.id))}>{item.id}</button>
                        <p className='step'>{item.text}</p>
                        <p className='paragraph'>{item.desc}</p>
                    </div>
                ))}
            </div>
             
          
            


        </div>
    )
}

export default Navigationbar
